/* Package JSON Import will be here */
import React from "react";
import { BackTop } from "antd";
/* Package JSON Import will be here */

const ScrollTop = (props) => {
    return (
        <BackTop className="scroll-position" target={() => props.targetClass !== undefined ? document.querySelector("." + props.targetClass) : window}>
            <div className="scroll-Top"><i className="fa fa-arrow-up"></i></div>
        </BackTop>
    )
}

export default ScrollTop;